import * as ActionTypes from '../constants/actiontypes/services';
import *  as axios from 'axios';
import * as urls from '../constants/webapi/services';
import { convertConnectionTypesToServiceType } from '../constants/utils/connectionTypes';

export function fetchServices(serviceType, position, name) {

	let frenchServiceType = convertConnectionTypesToServiceType(serviceType);

	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_SERVICES_REQUEST, serviceType: serviceType, position: position, name: name });
		return axios.get(urls.searchServiceUrl(frenchServiceType, position, name))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_SERVICES_SUCCESS,
					data: response.data,
					serviceType: serviceType
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response.status === 404) {
					dispatch({
						type: ActionTypes.FETCH_SERVICES_SUCCESS,
						serviceType: serviceType
					});
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_SERVICES_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getServiceById(serviceType, serviceId) {

	let frenchServiceType = convertConnectionTypesToServiceType(serviceType);
	return (dispatch) => {
		dispatch({ type: ActionTypes.GET_SERVICE_BY_ID_REQUEST, serviceType: serviceType, serviceId: serviceId });
		return axios.get(urls.getServiceByIdUrl(frenchServiceType, serviceId))
			.then((response) => {
				dispatch({
					type: ActionTypes.GET_SERVICE_BY_ID_SUCCESS,
					data: response.data
				});
				return response.data;
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.GET_SERVICE_BY_ID_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}


export function fetchServiceDataForServiceType(serviceType) {
	let frenchServiceType = convertConnectionTypesToServiceType(serviceType);
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_SERVICES_DATA_REQUEST, serviceType: serviceType });
		return axios.get(urls.getServiceDataByTypeUrl(frenchServiceType))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_SERVICES_DATA_SUCCESS,
					data: response.data,
					serviceType: serviceType
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.FETCH_SERVICES_DATA_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function fetchAllServiceData() {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_SERVICES_DATA_REQUEST });
		return axios.get(urls.getServiceDataUrl())
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_SERVICES_DATA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.FETCH_SERVICES_DATA_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function addServiceData(serviceData) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_SERVICES_DATA_REQUEST, serviceId: serviceData.serviceId });
		return axios.post(urls.getServiceDataUrl(), serviceData)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_SERVICES_DATA_SUCCESS,
					data: response.data,
					serviceId: serviceData.serviceId
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.ADD_SERVICES_DATA_FAILURE,
					response: error.response,
					serviceId: serviceData.serviceId
				});
				throw error.statusText;
			});
	};
}

export function updateServiceData(serviceData) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_SERVICES_DATA_REQUEST, id: serviceData.serviceId });
		return axios.put(urls.getServiceDataByIdUrl(serviceData.id), serviceData)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_SERVICES_DATA_SUCCESS,
					data: response.data,
					id: serviceData.serviceId
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.UPDATE_SERVICES_DATA_FAILURE,
					response: error.response,
					id: serviceData.serviceId
				});
				throw error.statusText;
			});
	};
}

export function deleteServiceData(id, connectionType) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_SERVICES_DATA_REQUEST, id: id, connectionType: connectionType });
		return axios.delete(urls.getServiceDataByIdUrl(id))
			.then(() => {
				dispatch({
					type: ActionTypes.DELETE_SERVICES_DATA_SUCCESS,
					id: id,
					connectionType: connectionType
				});
			})
			.catch((error) => {
				dispatch({
					type: ActionTypes.DELETE_SERVICES_DATA_FAILURE,
					response: error.response,
					id: id
				});
				throw error.statusText;
			});
	};
}